<template>
  <transition name="frisbuy-slide" @after-enter="startView">
    <div
      v-show="story"
      :class="{
        'frisbuy-preview-story': true,
        'frisbuy-preview-story--fixed': isStoryFixedView,
        'frisbuy-preview-popup':
          !isTablet &&
          (settings.widget.inlineDesktop == '1' ||
            settings.widget.popupPreview),
      }"
      @touchmove.self.prevent
      @click.self.stop="resumeStorie"
      @mousedown.stop
    >
      <PreviewCloseButton
        v-if="settings.widget.inlineDesktop == '1'"
        class="frisbuy-preview-close-button--desktop"
        @click="closePreview"
      />

      <div
        class="frisbuy-preview-wrapper"
        @click.self.stop="resumeStorie"
        @mousedown.stop
      >
        <div class="frisbuy-preview-area" v-touch:swipe.stop="swipePreview">
          <SlideWrapperElements
            :postCount="stories.length"
            :currentPostIndex="storyIndex >= 0 ? storyIndex : 0"
            :percentOfProgress="slideProgress"
            :isHideIg="settings.censorship.hide_ig"
            :isShowAccountLinks="settings.is_show_account_links == '1'"
            @selectStep="(index) => $emit('set-story', stories[index])"
            :igAccount="account"
            @clickInstagram="clickInstagram"
            :igSubscribeButtonText="settings.widget.subscribeButton"
            :isPause="isPause"
            @clickPause="isPause ? playSlide() : pauseSlide()"
            :isHasSound="Boolean(storyMedia && storyMedia.videoUrl && hasAudio)"
            :isSoundOn="playWithSound"
            @clickMute="playWithSound = !playWithSound"
            @clickClose="closePreview"
            :adsMarker="story?.adsMarker"
          />

          <StorySlider
            :stories="stories"
            :story="story"
            ref="slider"
            :opened-goods="openedGoods"
            :isShowNavigation="!isTablet || (isTablet && !isGoodsPopupOpen)"
            :isShowNavigationPrev="storyIndex > 0"
            :isShowNavigationNext="stories && storyIndex + 1 !== stories.length"
            @nextSlide="navigate(1)"
            @prevSlide="navigate(-1)"
            @getSlideProgress="(value) => (slideProgress = value)"
            @playSlide="() => (isPause = false)"
            @pauseSlide="() => (isPause = true)"
          >
          </StorySlider>

          <GoodsButton
            v-if="
              isShowGoodsButton &&
              storyMedia.linkList &&
              storyMedia.linkList.length > 0
            "
            :isGoodsPopupOpen="isGoodsPopupOpen"
            :text="goodsButton.text"
            :isLink="goodsButton.iconName === 'link'"
            :linkUrl="storyMedia.linkList[0].link"
            @clickButton="toggleGoodsList()"
            @clickLink="clickLink(storyMedia.linkList[0])"
          />

          <PopupTransitionWrapper
            :isPopupOpen="isGoodsPopupOpen"
            @swipe="(direction) => swipeDownPopup(direction)"
            style="z-index: 2"
          >
            <GoodsPopup
              v-if="isGoodsPopupOpen"
              :goods="storyMedia.linkList"
              :currencySymbol="settings.widget.currency"
              @clickLink="(good) => clickLink(good)"
              @closePopup="toggleGoodsList()"
            />
          </PopupTransitionWrapper>
        </div>
        <BrandingLogo
          v-if="!settings.widget.hideBrand"
          @click.self.stop
          :customerCode="settings.customerCode"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import { toRaw } from "vue";
import analytics from "../common/mixins/analytics";
import StorySlider from "./components/storySlider.vue";
import {
  GoodsPopup,
  GoodsButton,
  PreviewCloseButton,
  SlideWrapperElements,
  BrandingLogo,
} from "@/components/stories";
import PopupTransitionWrapper from "@/components/stories/GoodsPopup/PopupTransitionWrapper.vue";

export default {
  inject: ["isMobileLandscape"],

  data() {
    return {
      inView: false,
      isTablet: false,
      openedGoods: false,
      playWithSound: false,
      labelItemPosition: [
        "fbProduct",
        "igCode",
        "link",
        "linklabel",
        "offer",
        "swipeType",
      ],
      categoryPostfix: "SR",
      sourceInLoading: true,
      markersDirection: [],
      hasAudio: false,
      isGoodsPopupOpen: false,
      isShowGoodsButton: true,
      slideProgress: 0,
      isPause: false,
    };
  },

  emits: ["set-story", "close-preview"],

  props: ["story", "stories", "settings"],

  mixins: [analytics],

  components: {
    StorySlider,
    GoodsPopup,
    GoodsButton,
    PreviewCloseButton,
    SlideWrapperElements,
    PopupTransitionWrapper,
    BrandingLogo,
  },

  provide() {
    return {
      preview: this,
      resumeStorie: this.resumeStorie,
    };
  },

  computed: {
    currentStory() {
      const { stories, storyIndex } = this;

      return stories[storyIndex];
    },

    isStoryFixedView() {
      return !this.isInline;
    },

    isInline() {
      return (
        this.settings.widget.inlineDesktop == 1 ||
        (this.isMobileLandscape && !this.settings.widget.mobileFixed)
      );
    },

    listMarkers() {
      const { linkList } = this.storyMedia;

      return linkList.length && linkList.some((link) => !link.marker.show);
    },

    storyMedia() {
      const { story } = this;

      if (!story) return {};

      return story.media[0];
    },

    storyIndex() {
      const { stories, story } = this;

      return stories.indexOf(toRaw(story));
    },

    account() {
      const { story } = this;

      if (!story) return null;

      return story.instagramPost.authorUser;
    },

    hasLinks() {
      const { linkList } = this.storyMedia;

      return linkList.some(
        (link) =>
          !Object.hasOwn(link, "sku") ||
          (Object.hasOwn(link, "sku") && !Object.hasOwn(link.sku, "price"))
      );
    },

    goodsButton() {
      const { linkList } = this.storyMedia;

      let buttonText = "Показать товар";
      let buttonIconName = "goods";

      if (this.settings.widget.btn_text) {
        return {
          iconName: buttonIconName,
          text: this.settings.widget.btn_text,
        };
      }

      if (linkList && linkList.length !== 0) {
        const moreThanTwoLinks = linkList.length > 1;

        if (moreThanTwoLinks) {
          buttonText = "Показать товары";
        }

        if (this.hasLinks) {
          buttonText = "Перейти по ссылке";
          buttonIconName = "link";

          if (this.settings.dynamic_link_btn && linkList[0].title !== "") {
            buttonText = linkList[0].title;
          }

          if (moreThanTwoLinks) {
            buttonText = "Открыть детали";
            buttonIconName = "details";
          }
        }

        if (this.isGoodsPopupOpen) {
          buttonText = "Скрыть товар";
          buttonIconName = "goods";

          if (moreThanTwoLinks) {
            buttonText = "Скрыть товары";
          }

          if (
            !Object.hasOwn(linkList[0], "sku") ||
            !Object.hasOwn(linkList[0].sku, "price")
          ) {
            buttonText = "Закрыть детали";
            buttonIconName = "details";
          }
        }
      }

      return {
        iconName: buttonIconName,
        text: buttonText,
      };
    },

    defaultSoundStatus() {
      return this.settings.defaultSoundStatus;
    },
  },

  methods: {
    pauseSlide() {
      this.isPause = true;
      this.$refs.slider.pause();
    },

    playSlide() {
      this.isPause = false;
      this.$refs.slider.play();
    },

    stopSlide() {
      this.isPause = false;
      this.$refs.slider.stop();
    },

    soundSwitch() {
      this.playWithSound = !this.playWithSound;
    },

    closePreview() {
      this.stopPreview();
      this.$emit("close-preview");
    },

    stopPreview() {
      this.stopSlide();
      this.inView = false;

      this.unlockWindowScroll();
    },

    lockWindowScroll() {
      const customScrollElement = this.settings.scrollElement;
      if (customScrollElement) {
        document.querySelector(customScrollElement).style.overflow = "hidden";
      } else {
        document.body.style.overflow = "hidden";
      }
    },

    unlockWindowScroll() {
      const customScrollElement = this.settings.scrollElement;
      if (customScrollElement) {
        document.querySelector(customScrollElement).style.overflow = "";
      } else {
        document.body.style.overflow = "";
      }
    },

    clickInstagram() {
      this.sendAnalyticEvent("ClickInst", location.href, true, true);
    },

    clickLink(good) {
      const { story } = this;

      if (!this.isGoodsPopupOpen) {
        document.addEventListener(
          "visibilitychange",
          this.handleVisibilitychange
        );
      }

      this.sendAnalyticEvent("ClickLink", {
        provPostId:
          story.instagramPost?.frisbuyId ?? story.providerPost.frisbuyId,
        fbProduct: story.frisbuyPost.id,
        igCode: story.instagramPost.shortcode,
        link: good.id,
        linklabel: good.title,
        offer: good.sku.offerId,
        linkUrl: good.link,
      });
    },

    swipePreview(direction) {
      const { storyMedia, isGoodsPopupOpen } = this;
      const { linkList } = storyMedia;

      if (direction === "top" && linkList.length && !isGoodsPopupOpen) {
        if (this.goodsButton.iconName !== "link") {
          this.toggleGoodsList();
        }
      } else if (["left", "right"].includes(direction)) {
        if (this.isGoodsPopupOpen) {
          return;
        }

        const numberDirection = direction === "left" ? 1 : -1;

        this.navigate(numberDirection);
      }
    },

    navigate(direction) {
      this.stopSlide();
      this.showGoodsButtonAnimation();

      const nextStory = this.stories[this.storyIndex + direction];

      if (nextStory) {
        this.$emit("set-story", nextStory);

        this.$nextTick(() => {
          this.playSlide();
        });
      } else {
        this.closePreview();
      }
    },

    toggleGoodsList() {
      const { isGoodsPopupOpen } = this;

      if (this.goodsButton.iconName !== "link") {
        this.isGoodsPopupOpen = !isGoodsPopupOpen;
      }

      if (isGoodsPopupOpen) {
        this.playSlide();
      } else {
        this.pauseSlide();
      }
    },

    showGoodsButtonAnimation() {
      this.isShowGoodsButton = false;
      this.$nextTick(() => {
        this.isShowGoodsButton = true;
      });
    },

    startView() {
      this.inView = true;
      this.playSlide();

      this.$nextTick(() => {
        if (!this.isStoryFixedView || this.isTablet) {
          console.log("lockWindowScroll");
          this.lockWindowScroll();
        }
      });
    },

    checkAudio(video) {
      if (
        video.hasAudio ||
        video.mozHasAudio ||
        Boolean(video.webkitAudioDecodedByteCount) ||
        Boolean(video.audioTracks && video.audioTracks.length)
      ) {
        this.hasAudio = true;
      } else {
        this.hasAudio = false;
      }
    },

    resumeStorie() {
      if (this.isGoodsPopupOpen) {
        this.toggleGoodsList();
      }
    },

    handleVisibilitychange() {
      const { slider } = this.$refs;

      if (document.hidden && slider) {
        this.pauseSlide();
      }

      if (!document.hidden) {
        this.playSlide();

        document.removeEventListener(
          "visibilitychange",
          this.handleVisibilitychange
        );
      }
    },

    swipeDownPopup(direction) {
      if (
        direction === "bottom" &&
        this.storyMedia.linkList.length &&
        this.isGoodsPopupOpen
      ) {
        if (this.goodsButton.iconName !== "link") {
          this.isGoodsPopupOpen = false;
          this.playSlide();
        }
      }
    },

    getInstagramLinkData(link) {
      const splittedLink = link.split("/");

      const isInstagramPost = link.includes("instagram");
      if (!isInstagramPost) return "";

      const isTag = splittedLink.includes("tags");
      if (isTag) return `#${splittedLink[splittedLink.indexOf("tags") + 1]}`;

      const isLocation = splittedLink.includes("locations");
      if (isLocation) return "📌Локация";

      if (splittedLink.length === 5) return `@${splittedLink[3]}`;

      return "Пост";
    },

    windowResizeHandler() {
      this.isTablet =
        Math.min(window.innerWidth, screen.width) < 768 &&
        Math.min(window.innerHeight, screen.height) < 426;
    },
  },

  onbeforeMount() {
    this.windowResizeHandler();
  },

  mounted() {
    window.addEventListener("resize", this.windowResizeHandler, true);

    const { isTablet, settings } = this;
    const { inlineDesktop, popupPreview } = settings.widget;

    if (settings.defaultSoundStatus && settings.defaultSoundStatus === "1") {
      this.playWithSound = true;
    }

    if (isTablet || (!(inlineDesktop === "1") && !popupPreview)) return;

    document.body.append(this.$el);
  },

  unmounted() {
    window.removeEventListener("resize", this.windowResizeHandler);
  },

  watch: {
    story: {
      handler(newStory, oldStory) {
        const { popupPreview, isGoodsPopupOpen } = this.settings.widget;

        if (newStory && oldStory) {
          this.$nextTick(() => {
            this.playSlide();
          });
        }

        this.isPause = false;

        this.slideProgress = 0;

        this.shortList = true;
        this.isGoodsPopupOpen = isGoodsPopupOpen || false;

        if (!this.isTablet && !popupPreview) return;

        if (newStory && !oldStory) {
          // disableBodyScroll(this.$el, {
          //   allowTouchMove: (el) => {
          //     while (el && el !== document.body) {
          //       if (el.getAttribute("body-scroll-lock-ignore") !== null) {
          //         return true;
          //       }
          //       el = el.parentElement;
          //     }
          //   },
          // });
        }
      },
      immediate: true,
    },

    defaultSoundStatus() {
      if (this.settings.defaultSoundStatus) {
        this.playWithSound = this.settings.defaultSoundStatus === "1";
      }
    },
  },
};
</script>

<style lang="scss">
@import "../common/style/mixins.scss";

.frisbuy-preview-story {
  --frisbuy-story-slide-height: 96dvh;
  --frisbuy-story-slide-width: calc(
    var(--frisbuy-story-slide-height) * (9 / 16)
  );

  @media screen and (max-width: 767px) {
    --frisbuy-story-slide-height: 100dvh !important;
  }
}

.frisbuy-preview-story--fixed {
  width: unset !important;
  height: unset !important;

  .frisbuy-preview-area {
    .frisbuy-slide-wrapper-elements {
      .frisbuy-slide-wrapper-elements__header {
        margin: 0;
        padding: 8px 13px 0;

        .frisbuy-preview-close-button {
          display: block;
        }
      }

      .frisbuy-preview-close-button--desktop {
        display: none;
      }
    }
  }

  .frisbuy-slide-navigation--arrows {
    @media (min-width: 768px) {
      .frisbuy-slide-navigation {
        width: 100%;

        margin: 0;
        padding: 0 10px;

        &__button {
          background-color: transparent;
          box-shadow: none;

          opacity: 1;

          margin-right: 0;
          margin-left: 0;

          & > svg {
            color: #fff;

            width: 20px;
            height: 35px;
          }
        }
      }
    }
  }

  .frisbuy-popup-transition-wrapper {
    width: 100%;
    max-height: 100%;
    border-radius: 0;
  }

  .frisbuy-sr-branding {
    @media (min-width: 768px) {
      display: none;
    }
  }
}

.frisbuy-preview-close-button {
  &.frisbuy-preview-close-button--desktop {
    position: absolute;
    top: 30px;
    right: 37px;

    width: 24px;
    height: 24px;

    @media (max-width: 767px) {
      display: none;
    }
  }
}

.frisbuy-preview-story {
  display: flex;
  flex-direction: column;

  width: 100dvw;
  height: 100dvh;

  z-index: 1;

  * {
    user-select: none;
    box-sizing: border-box;
  }

  &:not(.frisbuy-preview-popup) {
    transform: translateX(0);
    transition: 1s transform 1s;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.24),
      0px 4px 16px rgba(0, 0, 0, 0.08);
    border-radius: 0 4px 4px 0;
    flex-grow: 1;

    @media screen and (min-height: 426px) {
      &:before {
        content: "";
        width: 80px;
        height: 100%;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.24),
          0px 4px 16px rgba(0, 0, 0, 0.08);
        position: absolute;
        transform: translateX(-80px);
      }
    }

    &.frisbuy-slide-leave-active {
      transition: transform 1s;
      transform: translateX(-100%);
    }

    &.frisbuy-slide-enter {
      transform: translateX(-100%);
    }

    .frisbuy-preview-wrapper {
      flex-grow: 1;
    }

    @media (max-width: 767px) {
      .frisbuy-preview-area {
        width: 100%;

        video {
          width: 100%;
        }
      }
    }
  }

  &.frisbuy-preview-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(#000000, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999999999999;

    .frisbuy-preview-wrapper {
      width: fit-content;
      height: fit-content;
    }

    .frisbuy-preview-area {
      order: 1;
      -webkit-overflow-scrolling: auto;

      width: auto;
      height: var(--frisbuy-story-slide-height);
      aspect-ratio: 9 / 16;

      @media (min-width: 768px) {
        border-radius: 10px;
      }
    }

    .frisbuy-account-name {
      color: #fff;
    }

    .frisbuy-account-subscribe {
      color: #fff;
      border-color: #fff;
    }

    .frisbuy-story-progress-bar {
      padding: 8px 0;
      margin-top: -25px;
    }

    .frisbuy-preview-markers {
      &.frisbuy-row-view {
        margin-top: -7px;
      }
    }

    @media (max-width: 567px) {
      .frisbuy-preview-area {
        width: 100%;

        video {
          width: 100%;
        }
      }
    }
  }

  .frisbuy-sr-branding {
    position: absolute;
    top: 95%;
    // left: calc(50% + 12vh);
    left: calc(50% + 26.1vh - 125px);
    z-index: 10;

    margin-top: 4%;
  }

  .frisbuy-preview-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;

    .frisbuy-sr-branding {
      right: 0;
    }
  }

  .frisbuy-preview-area {
    flex-grow: 1;
    border-top-right-radius: 4px;
    position: relative;
    width: 369px;
    background-color: rgba(0, 0, 0, 0.9);

    video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .frisbuy-preview-markers {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 11;
    pointer-events: none;
    padding-bottom: 60px;

    &.frisbuy-row-view {
      display: flex;
      align-items: flex-start;
      flex-direction: column-reverse;

      .frisbuy-preview-marker {
        position: static;
        width: auto;
        height: auto;
        border-radius: 0;
        border: none;
      }

      .frisbuy-preview-good {
        position: static;
        opacity: 1;
        pointer-events: all;
        margin: 5px 5px 0 15px;
        width: 200px;
      }
    }
  }

  .frisbuy-preview-marker {
    position: absolute;
    width: 1px;
    height: 1px;

    &.frisbuy-direction-left {
      .frisbuy-preview-good {
        right: 100%;
        margin-right: 15px;

        &:before {
          content: "";
          position: absolute;
          border-width: 10px 0 10px 10px;
          border-style: solid;
          border-color: transparent #222222 transparent;
          left: 100%;
          top: 15px;
        }

        &:after {
          height: 100%;
          left: 100%;
          width: 20px;
        }
      }
    }

    &.frisbuy-direction-right {
      .frisbuy-preview-good {
        left: 100%;
        margin-left: 15px;

        &:before {
          right: 100%;
          border-width: 10px 10px 10px 0;
          border-color: transparent #222222 transparent;
          top: 15px;
        }

        &:after {
          height: 100%;
          right: 100%;
          width: 20px;
        }
      }
    }

    &.frisbuy-direction-bottom {
      .frisbuy-preview-good {
        top: 100%;
        left: -88px;
        margin-top: 15px;

        &:before {
          border-width: 0 10px 10px 10px;
          border-color: #222222 transparent;
          bottom: 100%;
          left: 77px;
        }

        &:after {
          height: 20px;
          bottom: 100%;
          width: 100%;
        }
      }
    }

    &.frisbuy-direction-top {
      .frisbuy-preview-good {
        top: auto;
        bottom: 100%;
        left: -88px;
        margin-bottom: 15px;

        &:before {
          border-width: 10px 10px 0 10px;
          border-color: #222222 transparent;
          top: 100%;
          left: 77px;
        }

        &:after {
          height: 20px;
          bottom: 100%;
          width: 100%;
        }
      }
    }

    .frisbuy-preview-good {
      position: absolute;
      opacity: 1;
      pointer-events: all;
      width: 176px;
      top: -10px;
      &:before {
        content: "";
        position: absolute;
        border-style: solid;
      }

      &:after {
        content: "";
        position: absolute;
      }
    }
  }

  .frisbuy-preview-good {
    padding: 8px;
    text-align: left;
    display: flex;
    align-items: center;
    background-color: #222222;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.01em;
    text-decoration: none;
    transition: opacity 0.3s;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.24),
      0px 4px 16px rgba(0, 0, 0, 0.08);
    border-radius: 4px;

    svg {
      flex-shrink: 0;
    }
  }

  .frisbuy-preview-good-info {
    flex-grow: 1;
  }

  .frisbuy-preview-good-prices {
    display: flex;
    margin-top: 10px;
    align-items: center;
    justify-content: space-between;
  }

  .frisbuy-preview-good-old-price {
    text-decoration: line-through;
  }

  .frisbuy-short-toggler {
    background: #ffffff;
    font-size: 9px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: 0.01em;
    border: 1px solid #222222;
    color: #222222;
    padding: 3px 8px;
    cursor: pointer;
    margin-left: 5px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.24),
      0px 4px 16px rgba(0, 0, 0, 0.08);
    pointer-events: all;

    svg {
      margin-left: 5px;
    }
  }

  .frisbuy-account-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    flex-shrink: 0;
    background-position: center;
    background-size: cover;
    margin-right: 10px;
  }

  .frisbuy-account-name {
    flex-grow: 1;
    color: #fff;
    font-size: 13px;
    text-decoration: none;
  }

  .frisbuy-account-subscribe {
    flex-shrink: 0;
    border: 1px solid #222222;
    padding: 6px 21px;
    font-size: 13px;
    color: #222222;
    text-decoration: none;

    &:hover {
      background-color: #222222;
      color: #fff;
    }
  }

  .frisbuy-good-button {
    bottom: 25px;
  }

  .frisbuy-hide-goods {
    position: absolute;
    height: 32px;
    width: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #222;
    border-radius: 100%;
    left: 15px;
    bottom: 16px;
    z-index: 11;
    cursor: pointer;
  }

  @include screen-xs {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999999999;
    right: 0;
    bottom: 0;
    transition: none;
    transform: none !important;
    transition: none !important;

    &.frisbuy-slide-leave-active {
      transform: none;
    }

    &.frisbuy-slide-enter {
      transform: none;
    }

    .frisbuy-preview-markers {
      padding-bottom: 60px;
    }

    .frisbuy-account-name {
      color: #fff;
    }

    .frisbuy-account-subscribe {
      border: 1px solid #fff;
      color: #fff;
    }
  }

  @media (max-width: $screen-xxs-max) and (orientation: portrait) {
    .frisbuy-sr-branding {
      top: auto;
      bottom: 3px;
      left: unset;
      display: block !important;
      z-index: 10;

      svg {
        margin-left: 4px !important;
      }

      span {
        white-space: nowrap;
        justify-content: center;
      }
    }
  }

  @media (max-height: 700px) and (min-width: 768px) {
    &:before {
      width: 70px;
    }

    .frisbuy-preview-area {
      width: 292px;

      video {
        width: 292px;
      }
    }

    .frisbuy-account-name {
      max-width: 40%;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 10px;
    }
  }
}

.frisbuy-sr-right {
  .frisbuy-preview-story {
    transform: translateX(calc(-100% - 80px));
    border-radius: 4px 0 0 4px;

    &.frisbuy-slide-enter-from,
    &.frisbuy-slide-leave-to {
      transform: translateX(0);
    }

    &:before {
      content: "";
      width: 80px;
      height: 100%;
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.24),
        0px 4px 16px rgba(0, 0, 0, 0.08);
      position: absolute;
      transform: translateX(80px);
      right: 0;
      pointer-events: none;
    }

    .frisbuy-preview-area {
      border-top-right-radius: 0;
      border-top-left-radius: 4px;
    }
  }
}

@media screen and (max-height: 425px) and (orientation: landscape) {
  .frisbuy-sr-inline .frisbuy-preview-story {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    &:before {
      content: unset;
    }
  }

  .frisbuy-preview-story {
    background: rgba(#000000, 0.9) !important;
    display: flex;
    justify-content: center;
    align-items: center;

    .frisbuy-preview-good {
      min-width: 150px;
      max-width: 150px;
      font-size: 8px;
      .frisbuy-preview-good-prices {
        margin: 0;
      }
    }

    .frisbuy-story-slide {
      video {
        width: unset !important;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
      }
    }

    .frisbuy-preview-wrapper {
      height: 268px;
      flex-grow: unset !important;
    }

    .frisbuy-preview-area {
      order: 1;
      -webkit-overflow-scrolling: auto;
      width: 151px !important;
    }

    .frisbuy-account-name {
      color: #fff;
      max-width: unset;
      margin: 10px 0;
    }

    .frisbuy-account-subscribe {
      color: #fff;
      border-color: #fff;
    }

    .frisbuy-story-progress-bar {
      padding: 8px 0;
      margin-top: -15px;
    }

    .frisbuy-preview-markers {
      &.frisbuy-row-view {
        margin-top: -7px;
      }
    }

    .frisbuy-slide-navigation {
      width: calc(100% + 70px);
      margin-left: -35px;

      .frisbuy-slide-navigation__button {
        margin: 0 -7px;
        svg {
          display: block;
        }
      }
    }

    .frisbuy-hide-goods {
      background-color: #fff;
      bottom: 9px;
      height: 30px;
      width: 30px;
      svg {
        path,
        line {
          fill: #222;
          stroke: #222;
        }
      }
    }

    .frisbuy-hide-goods {
      left: -40px;
    }
  }
}
</style>
